// import React from "react";
// import { Navigate, Route, Routes } from "react-router-dom";
// import { ErrorPage1 } from "./ErrorPage1";
// import { ErrorPage2 } from "./ErrorPage2";
// import { ErrorPage3 } from "./ErrorPage3";
// import { ErrorPage4 } from "./ErrorPage4";
// import { ErrorPage5 } from "./ErrorPage5";
// import { ErrorPage6 } from "./ErrorPage6";

// export default function ErrorsPage() {
//   return (
//     <Routes>
//       <Navigate from="/error" exact={true} to="/error/error-v1" />
//       <Route path="/error/error-v1" component={ErrorPage1} />
//       <Route path="/error/error-v2" component={ErrorPage2} />
//       <Route path="/error/error-v3" component={ErrorPage3} />
//       <Route path="/error/error-v4" component={ErrorPage4} />
//       <Route path="/error/error-v5" component={ErrorPage5} />
//       <Route path="/error/error-v6" component={ErrorPage6} />
//     </Routes>
//   );
// }



import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';

const ERROR_VARIANTS = {
  'error-v1': { code: '404', title: 'Page Not Found',      subtitle: "The page you're looking for doesn't exist or has been moved.", icon: 'search' },
  'error-v2': { code: '403', title: 'Access Denied',       subtitle: "You don't have permission to view this resource.",             icon: 'lock'   },
  'error-v3': { code: '500', title: 'Server Error',        subtitle: 'Something went wrong on our end. We\'re working on it.',      icon: 'server' },
  'error-v4': { code: '503', title: 'Unavailable',         subtitle: 'The service is temporarily down. Please try again shortly.',  icon: 'cloud'  },
  'error-v5': { code: '401', title: 'Unauthorized',        subtitle: 'Your session may have expired. Please sign in again.',        icon: 'key'    },
  'error-v6': { code: '408', title: 'Request Timeout',     subtitle: 'The request took too long to complete. Please try again.',    icon: 'clock'  },
};

const Icon = ({ name }) => {
  const paths = {
    search: <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    lock:   <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    server: <><rect width="20" height="8" x="2" y="2" rx="2"/><rect width="20" height="8" x="2" y="14" rx="2"/><line x1="6" x2="6.01" y1="6" y2="6"/><line x1="6" x2="6.01" y1="18" y2="18"/></>,
    cloud:  <><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></>,
    key:    <><circle cx="7.5" cy="15.5" r="5.5"/><path d="m21 2-9.6 9.6"/><path d="m15.5 7.5 3 3L22 7l-3-3"/></>,
    clock:  <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
  };
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
      stroke="#5341C4" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

const ErrorDisplay = ({ variant = 'error-v1' }) => {
  const navigate = useNavigate();
  const { code, title, subtitle, icon } = ERROR_VARIANTS[variant] || ERROR_VARIANTS['error-v1'];

  return (
    <>
      <style>{`
        .err-wrap {
          min-height: 100vh;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
        .err-box {
          width: 100%;
          max-width: 420px;
          text-align: center;
          animation: errUp .35s cubic-bezier(.16,1,.3,1) both;
        }
        @keyframes errUp {
          from { opacity:0; transform:translateY(14px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .err-icon {
          width: 72px;
          height: 72px;
          border-radius: 18px;
          background: #f5f3ff;
          border: 1px solid #ece9ff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.75rem;
        }
        .err-badge {
          display: inline-block;
          font-size: 0.68rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #5341C4;
          background: #f5f3ff;
          border: 1px solid #ece9ff;
          border-radius: 100px;
          padding: 3px 11px;
          margin-bottom: 1.1rem;
        }
        .err-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 .65rem;
          letter-spacing: -.025em;
          line-height: 1.25;
        }
        .err-sub {
          font-size: .9rem;
          color: #6b7280;
          line-height: 1.65;
          margin: 0 0 2rem;
        }
        .err-rule {
          width: 36px;
          height: 2px;
          background: #5341C4;
          opacity: .2;
          border-radius: 2px;
          margin: 0 auto 2rem;
        }
        .err-actions {
          display: flex;
          gap: .625rem;
          justify-content: center;
        }
        .err-btn {
          height: 38px;
          padding: 0 1.1rem;
          border-radius: 8px;
          font-size: .855rem;
          font-weight: 500;
          font-family: inherit;
          cursor: pointer;
          border: none;
          display: inline-flex;
          align-items: center;
          transition: all .15s ease;
        }
        .err-btn-solid {
          background: #5341C4;
          color: #fff;
        }
        .err-btn-solid:hover {
          background: #4535b0;
          box-shadow: 0 3px 10px rgba(83,65,196,.28);
          transform: translateY(-1px);
        }
        .err-btn-outline {
          background: #fff;
          color: #374151;
          border: 1px solid #e5e7eb !important;
        }
        .err-btn-outline:hover {
          background: #f9fafb;
        }
        .err-foot {
          margin-top: 2rem;
          font-size: .775rem;
          color: #9ca3af;
        }
        .err-foot a { color: #5341C4; text-decoration: none; font-weight: 500; }
        .err-foot a:hover { text-decoration: underline; }
      `}</style>
      <div className="err-wrap">
        <div className="err-box">
          <div className="err-icon">
            <Icon name={icon} />
          </div>
          <span className="err-badge">Error {code}</span>
          <h1 className="err-title">{title}</h1>
          <p className="err-sub">{subtitle}</p>
          <div className="err-rule" />
          <div className="err-actions">
            <button className="err-btn err-btn-outline" onClick={() => navigate(-1)}>
              ← Back
            </button>
            <button className="err-btn err-btn-solid" onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </button>
          </div>
          <p className="err-foot">
            Need help? <a href="mailto:info@sety.io">Contact support</a>
          </p>
        </div>
      </div>
    </>
  );
};

const ErrorsPage = () => (
  <Routes>
    <Route index           element={<ErrorDisplay variant="error-v1" />} />
    <Route path="error-v1" element={<ErrorDisplay variant="error-v1" />} />
    <Route path="error-v2" element={<ErrorDisplay variant="error-v2" />} />
    <Route path="error-v3" element={<ErrorDisplay variant="error-v3" />} />
    <Route path="error-v4" element={<ErrorDisplay variant="error-v4" />} />
    <Route path="error-v5" element={<ErrorDisplay variant="error-v5" />} />
    <Route path="error-v6" element={<ErrorDisplay variant="error-v6" />} />
  </Routes>
);

export default ErrorsPage;